// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__m00xn","top":"styles_top__37Vyk"};